import { Button, ModalHead, ScrollBar, toastError, toastSuccess } from 'admination-react'
import { useEffect, useRef, useState } from 'react'
import { useApp } from '@/core/state/appStore'
import { me } from '@/core/data/session'
import { createModul } from '../../data/modul'
import { TextField } from '@/core/components/form/TextField'
import { Icon } from 'admination-react'
import { friendlyErrorMessage, isUniqueViolation } from '@/core/lib/dbError'

export function CreateModulModal() {
  const { dispatch, reloadMassnahmen } = useApp()
  const scrollerRef = useRef<HTMLElement>(null)
  const [name, setName] = useState('')
  const [organisationId, setOrganisationId] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    me()
      .then((m) => setOrganisationId(m.organisationId))
      .catch((e) => console.error('me() failed:', e))
  }, [])

  const close = () => dispatch({ type: 'CLOSE' })

  const ready = !!name.trim()

  const submit = async () => {
    if (!ready || !organisationId || busy) return
    setBusy(true)
    try {
      await createModul(organisationId, name.trim())
      reloadMassnahmen()
      setName('')
      toastSuccess('Modul angelegt.')
      close()
    } catch (e) {
      console.error('Modul anlegen fehlgeschlagen:', e)
      toastError(
        isUniqueViolation(e)
          ? 'Dieses Modul gibt es in diesem Katalog schon.'
          : friendlyErrorMessage(e, 'Anlegen fehlgeschlagen.'),
      )
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <ModalHead titleIcon="i-module" title="Neues Modul" actions={<>
          <div className="pill-cluster">
            <div className="pill">
              <Button
                type="button"
                primaryAction
                disabled={!ready || busy}
                onClick={() => void submit()}
              >
                <Icon name="i-check" />
                Anlegen
              </Button>
            </div>

          </div>
        </>} onClose={close} closeLabel="Schließen" />
      <main className="form" data-scroll-host ref={scrollerRef}>
        <div className="section">
          <h3 className="section-header">Neues Modul</h3>
          <div className="section-body">
            <TextField label="Name" value={name} onChange={setName} />
          </div>
        </div>
      </main>
      <ScrollBar scrollerRef={scrollerRef} />
    </>
  )
}
